import { Node, mergeAttributes } from "@tiptap/core";

// Campo de mesclagem (dados do residente/familiares/empresa).
// É um nó atômico e não editável: o usuário só pode inserir ou remover inteiro,
// nunca alterar o texto interno — garantindo que a referência não seja modificada.
export const MergeField = Node.create({
  name: "mergeField",
  group: "inline",
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      field: {
        default: null,
        parseHTML: (el) => el.getAttribute("data-field"),
        renderHTML: (attrs) => (attrs.field ? { "data-field": attrs.field } : {}),
      },
      label: {
        default: "",
        parseHTML: (el) => el.textContent,
        renderHTML: () => ({}),
      },
    };
  },

  parseHTML() {
    return [{ tag: "span[data-field]" }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, { class: "mf", contenteditable: "false" }),
      node.attrs.label || node.attrs.field || "",
    ];
  },
});
